<template>

  <div class="priceBlock" :dir="uiDirection">

    <div class="row">
      <div>{{ title }}</div>
      <div v-if="secondTitle"> \ {{ secondTitle }}</div>
    </div>

    <div class="priceBlockPrice">
      <Popper
          arrow
          :hover="true"
          :content="tooltip"
          v-if="tooltip"
      >
        <div class="tooltipIcon">
          <i class="ri-information-line"/>
        </div>
      </Popper>

      <div class="row">
        <div>
          {{ price }}
        </div>
        <div v-if="secondValue">
          \ {{ secondValue }}
        </div>
      </div>

    </div>



  </div>
</template>

<script>

import Popper from "vue3-popper";

export default {
  name: "symbolPagePriceBlock",
  props: ['title', 'price', 'tooltip', 'secondTitle', 'secondValue'],
  components: { Popper }
}
</script>

<style scoped lang="scss">

@import "../../assets/style/general";

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

</style>
